module.exports = __webpack_public_path__ + "img/hdyx_right_select.7b1f7b1f.png";